import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import uuidv4 from 'uuid/v4';

// import 'core-js';
// BROWSER POLYFILLS

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.jsx';
import * as serviceWorker from './serviceWorker';

// generate a nonce for the CSP header
const nonce = Buffer.from(uuidv4()).toString('base64');

// insert CSP style nonce so JSS can find it
const cspStyleNonceProp = document.createElement('meta');
cspStyleNonceProp.setAttribute('property', 'csp-nonce');
cspStyleNonceProp.setAttribute('content', nonce);
document.head.appendChild(cspStyleNonceProp);

// for development, allow localhost:5234 as a connect-src
let cspConnectSrc = '';
if (process.env.NODE_ENV === 'development') {
    cspConnectSrc = 'localhost:5234';
}
else {
    cspConnectSrc = 'hexacthost.danfoss.com';
}

// the inline script hash for the script in index.html that deals with MS IE
const cspInlineScriptHash = "sha256-zx0v6jwKboBysTQq/4ecuGxcFo1DuKHwKLXLypZHVio=";

// generate a CSP header
const csp = document.createElement('meta');
csp.setAttribute('http-equiv', 'Content-Security-Policy');
csp.setAttribute('content', `default-src 'self'; script-src 'self' '${cspInlineScriptHash}'; style-src 'self' 'nonce-${nonce}'; connect-src 'self' ${cspConnectSrc}; img-src 'self' data:; font-src 'self' data:; frame-src 'self'; frame-ancestors 'self';`);
document.head.appendChild(csp);

ReactDOM.render(<App/>, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
